import { Button, Card, Table, Text, Modal, TextInput, Loader, LoadingOverlay } from '@mantine/core'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import Layout from '../../Layout/Layout'
import { useSelector, useDispatch } from 'react-redux';
import { getJobTypes, createNewJobType, editExistingJobType, deleteExistingJobType } from '../../actions/jobActions';
import { useForm } from '@mantine/hooks';
import { useModals } from '@mantine/modals';
import { useNotifications } from '@mantine/notifications';
import moment from 'moment';

const General = ({ title, activeKey }) => {

    const dispatch = useDispatch();
    const modals = useModals();
    const notifications = useNotifications();
    const [editMode, setEditMode] = useState(false);
    const [selectedItem, setSelectedItem] = useState();
    const { loading: jobTypesLoading, jobTypes } = useSelector((state) => state.getJobTypes);
    const { loading: createJobTypeLoading, createJobType } = useSelector((state) => state.createJobType);
    const { loading: editJobTypeLoading, editJobType } = useSelector((state) => state.editJobType);
    const { deleteJobType } = useSelector((state) => state.deleteJobType);
    const [jobTypeModalOpen, setJobTypeModalOpen] = useState(false);


    const jobTypeForm = useForm({
        initialValues: {
            name: '',
        },
        errorMessages: {
            email: 'Enter a valid job type name'
        },
    });


    const handlerEditjobType = (jobType) => {
        jobTypeForm.setValues({ name: jobType.name });
        setEditMode(true)
        setSelectedItem(jobType)
        setJobTypeModalOpen(true)
    }


    const handlerJobType = (values) => {
        const { name } = values;

        if (editMode) {
            dispatch(editExistingJobType(selectedItem.id, name))
        } else {
            dispatch(createNewJobType(name))
        }

        setEditMode(false);
        setSelectedItem()
        setJobTypeModalOpen(false);
        setEditMode(false);
        jobTypeForm.reset();
    }

    const openConfirmModal = (id) => {
        modals.openConfirmModal({
            title: 'Cancel Job',
            centered: true,

            children: (
                <Text size="sm">
                    After deleting this, you will not be able recover it again.
                </Text>
            ),
            labels: { confirm: 'Cancel Job', cancel: "Close" },
            confirmProps: { color: 'red' },
            onConfirm: () => dispatch(deleteExistingJobType(id)),
        });
    }

    useEffect(() => {
        if (createJobType || editJobType || deleteJobType) {
            dispatch(getJobTypes())
        }
        // eslint-disable-next-line
    }, [createJobType, editJobType, deleteJobType])

    useEffect(() => {
        if (createJobType || editJobType || deleteJobType) {
            dispatch(getJobTypes())
        }

        if (deleteJobType) {
            notifications.showNotification({
                title: 'Success',
                message: 'Job Type deleted',
                color: 'red'
            })
        } else if (createJobType) {
            notifications.showNotification({
                title: 'Success',
                message: 'Job Type created',
                color: 'green'
            })
        } else if (editJobType) {
            notifications.showNotification({
                title: 'Success',
                message: 'Job Type modified',
                color: 'green'
            })
        }
        // eslint-disable-next-line
    }, [createJobType, editJobType, deleteJobType])

    useEffect(() => {
        dispatch(getJobTypes())
    }, [dispatch])

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{title}</title>
            </Helmet>

            <Layout activeKey={7}>
                <Modal onClose={() => setJobTypeModalOpen(false)} radius='md' centered opened={jobTypeModalOpen}>
                    <form onSubmit={jobTypeForm.onSubmit((values) => handlerJobType(values))}>
                        <TextInput
                            {...jobTypeForm.getInputProps('name')}
                            radius='md'
                            sx={{ marginTop: '20px', width: '100%', fontFamily: 'Poppins' }}
                            placeholder="Type"
                            label="Job Type"
                            size='sm'
                            required
                            error={jobTypeForm.errors.name}
                        />
                        <Button loading={editMode ? editJobTypeLoading : createJobTypeLoading} type='submit' color='orange' radius='md' fullWidth sx={{ marginTop: '20px' }}>{editMode ? 'Edit' : 'Add'} Job Type</Button>
                    </form>
                </Modal>
                <Card radius='md' shadow='xl'>
                    <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px' }}>
                        <Text weight={700} size='xl'>Job Types</Text>
                        <Button color='orange' radius='md' onClick={() => setJobTypeModalOpen(true)}>Add Job Type</Button>
                    </span>
                    {jobTypesLoading ? <LoadingOverlay visible={jobTypesLoading} loader={<Loader color='orange' />} /> :
                        <Table highlightOnHover>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Created</th>
                                    <th>Updated</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {jobTypes && jobTypes.map((jobType, key) => {
                                    return <tr key={key}>
                                        <td>{jobType.name}</td>
                                        <td>{moment(jobType.createdAt).format('DD-MMM-YYYY HH:mm')}</td>
                                        <td>{moment(jobType.updatedAt).format('DD-MMM-YYYY HH:mm')}</td>
                                        <td>
                                            <Button color='blue' variant='light' radius='md' fullWidth onClick={() => handlerEditjobType(jobType)}>
                                                Edit
                                            </Button>
                                        </td>
                                        <td>
                                            <Button color='red' variant='light' radius='md' fullWidth onClick={() => openConfirmModal(jobType.id)}>
                                                Delete
                                            </Button>
                                        </td>
                                    </tr>
                                })}


                            </tbody>
                        </Table>}

                </Card>
            </Layout>
        </>
    )
}

export default General
